import { useContext } from 'react';
import LevelsContext from '../contexts/LevelsContext';

const useLevels = () => useContext(LevelsContext);

export default useLevels;
